import { deserializeTeam, fetchTeamBySlug } from 'supporticon/api/teams'
import { createAction } from 'supporticon/utils/actions'
import { createReducer } from 'supporticon/utils/reducers'
import { isJustGiving } from '../../lib/environment'
import { selectAPIParams } from '../site'

// Constants
const NAMESPACE = 'app/teams'

// Selectors
export * from './selectors'

// Action
export const fetchTeam = (slug, campaign) => (dispatch, getState) => {
  const state = getState()
  const { apiParams } = selectAPIParams(state)

  console.log(apiParams)

  return dispatch(createAction({
    namespace: NAMESPACE,
    fetcher: isJustGiving() ? fetchJGTeam(slug, apiParams) : fetchEDHTeam(slug, campaign)
  }))
}

const fetchJGTeam = (slug, params = {}) =>
  fetchTeamBySlug(slug, {
    includeFitness: true,
    includePages: true,
    fitnessParams: {
      startDate: params.startDateTime,
      endDate: params.endDateTime
    }
  })

const fetchEDHTeam = (slug, campaign) =>
  fetchTeamBySlug({
    slug,
    campaignSlug: campaign.slug,
    countryCode: campaign.countryCode
  })

const customDeserializeTeam = data => {
  const team = deserializeTeam(data)

  return {
    ...team,
    raised: team.members.reduce((total, member) => total + member.raised, 0),
    url: `/teams/${team.slug}`
  }
}

// Reducer
export default createReducer({
  namespace: NAMESPACE,
  deserialize: customDeserializeTeam
})
